import React, { useCallback } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { copyToClipboard } from 'tennders-stracture/libs/utils'
import DOMPurify from 'dompurify'
// icons
import { useToast } from 'tennders-common/hooks/useToast'
import IconCopy from '../../../../../icons/icon-copy.svg'

const TruckDetailsTable = ({ allDetails, truckPlate, trailerPlate }) => {
  const { t } = useTranslation()
  const { toastSuccess } = useToast()

  const copyContent = useCallback(() => {
    let toCopy = ''
    toCopy += t('transaction:requested_truck') + ': ' + allDetails.replace(/(<([^>]+)>)/ig, '') + ' \n'
    toCopy += t('transaction:truckPlateNumber') + ': ' + truckPlate + ' \n'
    toCopy += t('transaction:trailerPlateNumber') + ': ' + trailerPlate
    copyToClipboard(toCopy)
    toastSuccess(t('common:copied'))
  }, [allDetails, truckPlate, trailerPlate])

  return (
    <div className="d-flex flex-col pl-10">
      <span className="bold mb-16" style={{ fontSize: '13px' }}>{t('transaction:truck_details')}:</span>
      <div className="tennders-grid-5-col">
        {/* First Row */}
        <div className="bold column-2">{t('transaction:requested_truck')}:</div>
        <div className="column-2" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(allDetails) }} />
        <div className="column-1">
          <span style={{ marginTop: '-3px' }}>
            <IconCopy className="cursor-pointer" onClick={copyContent} />
          </span>
        </div>
        {/* Second Row */}
        <div className="bold column-2 mt-6">{t('transaction:truckPlateNumber')}:</div>
        <div className="column-3 mt-6">{truckPlate}</div>
        {/* Third Row */}
        <div className="bold column-2 mt-6">{t('transaction:trailerPlateNumber')}:</div>
        <div className="column-3 mt-6">{trailerPlate}</div>
      </div>
    </div>
  )
}

export default React.memo(TruckDetailsTable)
